import React from 'react';

import { LegacyTextList, styled } from '@gogame/components';

const ItemsList = ({ data, fieldsForRender = [], className }) => {
  const createTemplate = (data, fieldsForRender) => {
    return fieldsForRender.map((field, index) => {
      return (
        <div className={className} key={index}>
          <LegacyTextList
            limit={1}
            size={'14px'}
            data={data[field]}
            unitsName={field}
            placeholder={`All ${field}`}
          />
        </div>
      );
    });
  };

  return createTemplate(data, fieldsForRender);
};

export default styled(ItemsList)`
  position: relative;
  margin: 0 8px;

  &:not(:last-child):after {
    content: '/';
    position: absolute;
    color: ${(props) => props.theme.palette.text.primary};
    top: 50%;
    right: -10px;
    transform: translateY(-50%);
  }
`;
